import { HourlyForecastWrapperLazy } from './hourlyForecastWrapperLazy';

const props = [];

export const HourlyForecastWrapperDirective = reactDirective => reactDirective(HourlyForecastWrapperLazy, props);
HourlyForecastWrapperDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('hourlyForecastWrapper', HourlyForecastWrapperDirective);
